module.exports = __webpack_public_path__ + "static/media/rules.7253485a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/rules.png
// module id = 221
// module chunks = 0